import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

const LOCATION_OPTIONS = [
  { label: 'Head', value: 'head' },
  { label: 'Body', value: 'body' },
  { label: 'Footer', value: 'footer' },
]

const WITH_RULES_OPTIONS = [
  { label: 'True', value: '{"$not":null}' },
  { label: 'False', value: '{"$eq":null}' },
]

export default function useFilters() {
  return useMemo(() => [
    filter.options.list('location', 'Location', LOCATION_OPTIONS).multi(true),
    filter.options.list('rules', 'With Rules', WITH_RULES_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
    filter.boolean('active', 'Active'),
  ], [])
}
